import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 300000,
  parentId: 0,
  name: "Dev",
  label: "Dev",
  path: "dev",
  icon: "lab-test",
  element: Element,
  admin: false,
  hidden: false,
};

export default route;
